// MATERIAL UI
import { Link, Stack, Typography } from "@mui/material";

export default function Disclaimer() {
  const disclaimerMessage =
    "*Pricing displayed on this trade is indicative and may be subject to change due to available liquidity and timing. Read our ToB ";
  return (
    <Stack direction={"row"} spacing={1} ml={2}>
      <Typography
        style={{
          alignContent: "center",
          alignSelf: "center",
          fontSize: "14px",
        }}>
        {disclaimerMessage}
        <Link
          href={"https://www.calebandbrown.com/terms-of-business"}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ fontWeight: "bold" }}>
          here.
        </Link>
      </Typography>
    </Stack>
  );
}
